import { render, staticRenderFns } from "./dashboard-index.vue?vue&type=template&id=0aede6d6&scoped=true&"
import script from "./dashboard-index.vue?vue&type=script&lang=js&"
export * from "./dashboard-index.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-index.vue?vue&type=style&index=0&id=0aede6d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aede6d6",
  null
  
)

export default component.exports